export default {
    template: require('./subscriptionSwitchStandardOffer.jade')(),
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/subscription/modal/subscriptionSwitchStandardOffer.js